export default __webpack_public_path__ + "static/media/yfi.421d02f2.svg";